import { ActionTree } from 'vuex';
import { GoogleDocsHelper } from '@/google-docs/helpers/google-docs.helper';
import {
  EGoogleDocsAction,
  EGoogleDocsMutation,
  state as defaultState,
} from '@/google-docs/store/google-docs.constants';
import { IGoogleDocsState } from '@/google-docs/store/google-docs.types';
import { RootState } from '@/store/store';
import { GoogleService } from '@/api/google/google.service';
import { IDocument } from '@/types/Document';
import { IGoogleDocsDTO } from '@/api/google/types/google-docs-dto';
import { translate } from '@/helpers/translation.helper';

export const actions: ActionTree<IGoogleDocsState, RootState> = {
  async [EGoogleDocsAction.LoadDocuments]({ commit, dispatch }) {
    commit(EGoogleDocsMutation.SetImported, false);
    commit(EGoogleDocsMutation.SetImporting, true);
    try {
      const documents: IGoogleDocsDTO[] = await GoogleService.getDocuments();
      if (documents.length === 0) {
        dispatch('alert/showInfoAlert', translate('no-new-docs-detected'), {
          root: true,
        });
      }
      const mappedDocuments: Partial<IDocument>[] = GoogleDocsHelper.convertDTOs(documents);
      dispatch(EGoogleDocsAction.LoadDocumentsSuccess, mappedDocuments);
    } catch (error) {
      dispatch(EGoogleDocsAction.LoadDocumentsFailed);
    }
  },
  [EGoogleDocsAction.LoadDocumentsSuccess]({ commit }, documents: Partial<IDocument>[]) {
    commit(EGoogleDocsMutation.SetDocuments, documents);
    commit(EGoogleDocsMutation.SetImporting, false);
    commit(EGoogleDocsMutation.SetImported, true);
  },
  [EGoogleDocsAction.LoadDocumentsFailed]({ commit, dispatch }) {
    commit(EGoogleDocsMutation.SetImported, false);
    commit(EGoogleDocsMutation.SetImporting, false);
    dispatch('alert/showDangerAlert', translate('failed-to-fetch-google-docs'), {
      root: true,
    });
  },
  [EGoogleDocsAction.Reset]({ commit }) {
    commit(EGoogleDocsMutation.SetState, { ...defaultState });
  },
};
